import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import { UserActiveOrg_DataFragmentDoc } from '../../../../config/user/UserProvider.graphql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OriginalInviterFragment = { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null, active_org?: { org: { id: string, name: string, org_avatar?: { public_url: string } | null } } | null };

export type NavigationDrawer_UserQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type NavigationDrawer_UserQuery = { user?: { id: string, first_name: string, last_name: string, full_name?: string | null, user_avatar?: { public_url: string } | null, contact?: { id?: string | null, email?: string | null } | null, active_org?: { org: { id: string, name: string, background?: string | null, address?: { lat?: number | null, lng?: number | null } | null, org_avatar?: { public_url: string } | null, project?: { id: string } | null } } | null, projects: Array<{ project: { id: string, name: string, is_demo: boolean, project_avatar?: { public_url: string } | null, labels: Array<{ id: string, color: string, name: string }>, org_project_summary?: Array<{ id: string, is_project_template: boolean, is_archived: boolean, project_groups: Array<{ project_group: { color: string, name: string, project_group_avatar?: { public_url: string } | null } }>, project_categories: Array<{ id: string, project_category: { color: string, name: string, id: string } }> }> | null } }>, originalInviter: Array<{ inviter?: { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null, active_org?: { org: { id: string, name: string, org_avatar?: { public_url: string } | null } } | null } | null }> } | null };

export type NavigationDrawer_OrgQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;


export type NavigationDrawer_OrgQuery = { org?: { id: string, project_groups: Array<{ color: string, name: string, project_group_avatar?: { public_url: string } | null }>, settings?: { show_menu_by_group: boolean } | null } | null };

export const OriginalInviterFragmentDoc = gql`
    fragment originalInviter on users {
  id
  full_name
  user_avatar {
    public_url
  }
  active_org {
    org {
      id
      name
      org_avatar {
        public_url
      }
    }
  }
}
    `;
export const NavigationDrawer_UserDocument = gql`
    query NavigationDrawer_user($id: uuid!) {
  user: users_by_pk(id: $id) {
    id
    user_avatar {
      public_url
    }
    contact {
      id
      email
    }
    first_name
    last_name
    full_name
    active_org {
      ...UserActiveOrg_data
    }
    projects(
      order_by: {project: {name: asc}}
      where: {project: {id: {_is_null: false}, _not: {org: {id: {_is_null: false}}}, _or: [{_or: [{is_archived: {_eq: false}}, {org_project_summary: {_and: [{is_archived: {_eq: false}}]}}]}, {members: {user: {_and: [{company_name: {_is_null: true}}, {id: {_eq: $id}}]}}}]}}
    ) {
      project {
        id
        name
        project_avatar {
          public_url
        }
        labels {
          id
          color
          name
        }
        org_project_summary {
          id
          is_project_template
          is_archived
        }
        is_demo
        org_project_summary {
          id
          project_groups {
            project_group {
              color
              name
              project_group_avatar {
                public_url
              }
            }
          }
          id
          project_categories(order_by: {order: asc_nulls_first}) {
            id
            project_category {
              color
              name
              id
            }
          }
        }
      }
    }
    originalInviter: projects(order_by: {created_at: asc}, limit: 1) {
      inviter {
        ...originalInviter
      }
    }
  }
}
    ${UserActiveOrg_DataFragmentDoc}
${OriginalInviterFragmentDoc}`;

export function useNavigationDrawer_UserQuery(options: Omit<Urql.UseQueryArgs<NavigationDrawer_UserQueryVariables>, 'query'>) {
  return Urql.useQuery<NavigationDrawer_UserQuery, NavigationDrawer_UserQueryVariables>({ query: NavigationDrawer_UserDocument, ...options });
};
export const NavigationDrawer_OrgDocument = gql`
    query NavigationDrawer_org($orgId: uuid!) {
  org: orgs_by_pk(id: $orgId) {
    id
    project_groups(order_by: {name: asc}) {
      color
      name
      project_group_avatar {
        public_url
      }
    }
    settings {
      show_menu_by_group
    }
  }
}
    `;

export function useNavigationDrawer_OrgQuery(options: Omit<Urql.UseQueryArgs<NavigationDrawer_OrgQueryVariables>, 'query'>) {
  return Urql.useQuery<NavigationDrawer_OrgQuery, NavigationDrawer_OrgQueryVariables>({ query: NavigationDrawer_OrgDocument, ...options });
};